export default class Pararax{
    constructor(inc){

        this.$prarax = document.querySelectorAll('.js__psc');
        this.paraPoint = [];
        this.paraNum = this.$prarax.length;


        /*  ステータスをセット */
        this.status = [];

        for(var i=0; this.paraNum>i; i++){
            var $p = this.$prarax[i];

            this.status[i] = {
                rate : $p.getAttribute('data-rate'),
                type : ""
            }

            if($p.classList.contains("js__dir-y")){
                this.status[i].type = "dir-y";
            }else if($p.classList.contains("js__dir-y-minus")){
                this.status[i].type = "dir-y-minus";
            }else if($p.classList.contains("js__dir-scale")){
                this.status[i].type = "dir-scale";
            }else{
                this.status[i].type = "dir-default";
            }

        }

        // this.datGUI();

    }
    check(inc,winH,param){

        if(param.displayType === 'sp') return;

        for(var i=0; this.paraNum>i; i++){

            if(this.paraPoint[i].start < inc && this.paraPoint[i].end > inc  ) {
                var $p = this.$prarax[i];

                var pInc = ( inc - this.paraPoint[i].base ) * this.status[i].rate;

                switch (this.status[i].type){
                    case "dir-y":
                        TweenMax.set(this.$prarax[i],{
                            "y":-pInc
                        });
                        break;
                    case "dir-y-minus":
                        TweenMax.set(this.$prarax[i],{
                            "y":pInc
                        });
                        break;
                    case "dir-scale":
                        let _pinc = 1.1 + pInc / 280;
                        TweenMax.set(this.$prarax[i],{
                            "scale":_pinc
                        });
                        break;
                    default :
                        TweenMax.set(this.$prarax[i],{
                            "x":-pInc/2
                        });
                        break;
                }

            }

        }
    }

    resize (winH) {
        this.paraPoint = [];
        for (var i = 0; i < this.paraNum; i++) {

            let $p = this.$prarax[i];

            this.paraPoint[i] = {
                base  : $p.getBoundingClientRect().top,
                start : $p.getBoundingClientRect().top - winH,
                end   : $p.getBoundingClientRect().top + winH,
            }

        }
    }


    datGUI(){
        let _gui = new dat.gui.GUI();

        _gui.remember(effect);
        // //

        var _f1 = _gui.addFolder('bodybg');
        // _f1.add(effect.conf, 'rotRadius', 0, 90);
        _f1.add(effect.conf, 'scrollInc', 0.00, 2.00);
        _f1.add(effect.conf, 'transY', 0.00, 2.00);
        _f1.add(effect.conf, 'transX', 0.00, 2.00);
        // let startPosiX = _f1.add(effect.conf, 'startPosiX', 0, 1000);
        // _f1.add(effect.conf, 'transZ', 0.00, 2.00);
        _f1.add(effect.conf, 'transRot', -2.00, 2.00);


    }

}